<template>
    <div class="h-pm-gnb-dataQuery-tree">
        <ejs-treeview ref='gnbPmCounterLeftTree' :fields='fieldsOfCounterManagementTree' :nodeSelected="nodeSelectedOfGnbCounterManagementTree"></ejs-treeview>
    </div>
</template>

<script>

export default {
    name: 'GnbPmCounterLeftTree',
    components: {
    },
    data() {
        return {
            fieldsOfCounterManagementTree: {
                dataSource: [],
                id: 'id',
                parentID: 'parentId',
                text: 'name',
                hasChildren: 'hasChildren',
                expanded: 'expanded'
            }
        }
    },
    methods: {

        nodeSelectedOfGnbCounterManagementTree(args){
            const params = this.$refs.gnbPmCounterLeftTree.getTreeData(args.nodeData.id)[0];
            this.$emit('gnbCounterTreeClick', params);
        },

        initGnbPmCounterTree(){
            this.$axios.get('/lte/ems/pm/gnb/counter/getCounterManagementTree.html').then((response) => {
                this.fieldsOfCounterManagementTree = {
                    dataSource: response.data.resultVal,
                    id: 'id',
                    parentID: 'parentId',
                    text: 'name',
                    hasChildren: 'hasChildren',
                    expanded: 'expanded'
                };
            });
        }
    },
    mounted() {
        this.initGnbPmCounterTree();
    }
};
</script>

<style>

</style>
